import axios from "axios";
import { API } from "./api";

const http = axios.create({ withCredentials: true });

export async function adminLogin(token) {
  const { data } = await http.post(`${API}/admin/login`, { token });
  return data;
}
export async function adminLogout() {
  const { data } = await http.post(`${API}/admin/logout`);
  return data;
}
export async function adminVerify() {
  const { data } = await http.get(`${API}/admin/verify`);
  return data;
}
export async function adminStats() {
  const { data } = await http.get(`${API}/admin/stats`);
  return data;
}
export async function adminSignups(_token, kind) {
  const { data } = await http.get(`${API}/admin/signups${kind ? `?kind=${kind}` : ""}`);
  return data;
}
export async function adminRides(_token, state) {
  const { data } = await http.get(`${API}/admin/rides${state ? `?state=${state}` : ""}`);
  return data;
}
export async function adminPricing() {
  const { data } = await http.get(`${API}/admin/pricing`);
  return data;
}
export async function adminUpdatePricing(_token, city, payload) {
  const { data } = await http.put(`${API}/admin/pricing/${encodeURIComponent(city)}`, payload);
  return data;
}
